import { generateEllipsePath } from '../../../../../utilities/PathGenerator/PathGenerator';

const getPath = shape => generateEllipsePath(
    shape.get('width') / 2,
    shape.get('height') / 2
).buildString();

export default getPath;
